(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
function initKndrckMenu(){
  const dialog=document.getElementById('KndrckMenu');
  const trigger=document.querySelector('.km-toggle');
  if(!dialog||!trigger||trigger.dataset.ready)return;
  trigger.dataset.ready='true';
  trigger.addEventListener('click',()=>{dialog.showModal();trigger.setAttribute('aria-expanded','true');document.documentElement.classList.add('km-open');});
  dialog.querySelector('.km-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX>box.right||event.clientX<box.left)dialog.close();}});
  dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('km-open');trigger.focus();});
  dialog.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>dialog.close()));
}
initKndrckMenu();
document.addEventListener('shopify:section:load',initKndrckMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kndrck-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kndrck-bestsellers')) {
  customElements.define('kndrck-bestsellers', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.kb-track');
      this.pause = this.querySelector('[data-pause]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.visible = false;
      this.updatePause = () => { this.pause.textContent = this.paused ? 'Nadaljuj' : 'Premor'; this.pause.setAttribute('aria-pressed', String(this.paused)); };
      this.updatePause();
      this.pause.onclick = () => { this.paused = !this.paused; this.updatePause(); };
      this.querySelector('[data-prev]').onclick = () => this.move(-1);
      this.querySelector('[data-next]').onclick = () => this.move(1);
      this.onmouseenter = () => { this.hovered = true; };
      this.onmouseleave = () => { this.hovered = false; };
      this.track.onpointerdown = () => { this.paused = true; this.updatePause(); };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold:0.2});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 3000);
    }
    move(direction) {
      const card = this.track.querySelector('.kb-card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      const end = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= end - 2) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) target = end;
      this.track.scrollTo({left:target,behavior:this.reduced.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kndrck-lastpieces"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kndrck-lastpieces')) {
  customElements.define('kndrck-lastpieces', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.klp-track');
      if (!this.track.querySelector('.klp-card')) { this.closest('section').hidden = true; return; }
      this.pause = this.querySelector('[data-pause]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.visible = false;
      this.updatePause = () => { this.pause.textContent = this.paused ? 'Nadaljuj' : 'Premor'; this.pause.setAttribute('aria-pressed', String(this.paused)); };
      this.updatePause();
      this.pause.onclick = () => { this.paused = !this.paused; this.updatePause(); };
      this.querySelector('[data-prev]').onclick = () => this.move(-1);
      this.querySelector('[data-next]').onclick = () => this.move(1);
      this.onmouseenter = () => { this.hovered = true; };
      this.onmouseleave = () => { this.hovered = false; };
      this.track.onpointerdown = () => { this.paused = true; this.updatePause(); };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold:0.2});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 3000);
    }
    move(direction) {
      const card = this.track.querySelector('.klp-card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      const end = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= end - 2) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) target = end;
      this.track.scrollTo({left:target,behavior:this.reduced.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kndrck-sale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kndrck-sale')) {
  customElements.define('kndrck-sale', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.klp-track');
      if (!this.track.querySelector('.klp-card')) { this.closest('section').hidden = true; return; }
      this.pause = this.querySelector('[data-pause]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.visible = false;
      this.updatePause = () => { this.pause.textContent = this.paused ? 'Nadaljuj' : 'Premor'; this.pause.setAttribute('aria-pressed', String(this.paused)); };
      this.updatePause();
      this.pause.onclick = () => { this.paused = !this.paused; this.updatePause(); };
      this.querySelector('[data-prev]').onclick = () => this.move(-1);
      this.querySelector('[data-next]').onclick = () => this.move(1);
      this.onmouseenter = () => { this.hovered = true; };
      this.onmouseleave = () => { this.hovered = false; };
      this.track.onpointerdown = () => { this.paused = true; this.updatePause(); };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold:0.2});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 3000);
    }
    move(direction) {
      const card = this.track.querySelector('.klp-card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      const end = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= end - 2) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) target = end;
      this.track.scrollTo({left:target,behavior:this.reduced.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
